export default "__VITE_ASSET__DFyb$1ce__"